import { useEffect, useState } from 'react';

export default function useDeviceType (){
  const [device, setDevice] = useState('desktop');

  useEffect(() => {
    const width = window.innerWidth;
    if (width < 768) setDevice('mobile');
    else if (width < 1000) setDevice('tablet');
    else setDevice('desktop');
  }, []);

  return device;
}